/**
 * Set at build time with REACT_APP_PLATFORM=mobile.
 * Web builds: isMobile = false
 * Capacitor builds: isMobile = true
 */
export const isMobile = process.env.REACT_APP_PLATFORM === 'mobile';

/**
 * Navigate to the plans page.
 * On mobile (reader app model): opens ataric.com.br/planos in the system browser.
 * On web: uses React Router navigation.
 */
export function openPlans(navigate: (path: string) => void) {
  if (isMobile) {
    window.open('https://ataric.com.br/planos', '_blank');
  } else {
    navigate('/planos');
  }
}
